import rupeeFormat from "components/Api/RupeeFormat";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { common } from "Data/common";

const SafariPackageCard = ({ safariPackages }) => {
  const [imageError, ] = useState(false);

  const PACKAGE = common?.SAFARI_PACKAGE?.HOME?.CARD;

  // const imageSrc = safariPackages.image_path && !imageError ? safariPackages.image_path : DummyImage;

  const displayText = (text) => {
    return text && text.trim() !== "" ? text : "N/A";
  };

  return (
    <div className="sharesafri-card tourpackage">
      <div className="flotingdate">
        <div className="icons text-center">
          <p className="mb-0">
            {displayText(safariPackages.package_day_night_labels)}
          </p>
        </div>
      </div>

      <div className="floating-watchlist"></div>

      <div className="shareimg">
        <Link
          to={`/package/${safariPackages?.partner?.slug}/${safariPackages.package_slug}`}
        >
          {imageError ? (
            <div
              style={{
                width: "100%",
                height: "232px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // border: "1px solid #ddd",
                fontStyle: "italic",
                borderRadius: "10px 10px 0px 0px",
                overflow: "hidden", // prevents ove
              }}
            >

            </div>
          ) : (
            <img
              src={safariPackages.image_path || "/img/placeholder.jpg"}
              alt={safariPackages.package_display_name}
              // onError={() => setImageError(true)}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/img/placeholder.jpg";
              }}
            />
          )}


        </Link>
      </div>

      <div className="card_body">
        <div className="titleDate">
          <h6 className="pt-1">
            <Link
              to={`/package/${safariPackages?.partner?.slug}/${safariPackages.package_slug}`}
            >
              {displayText(safariPackages.package_display_name)}
            </Link>
          </h6>

          <div className="orgnizer_tour d-flex justify-content-between py-2 px-3">
            <div className="icons_restro">
              <i className="fa-solid fa-car-side"></i>
              <p className="mb-0">
                {displayText(safariPackages?.partner?.park_count?.toString())}
              </p>
            </div>

            <div className="icons_restro">
              <i className="fa-solid fa-car"></i>
              <p className="mb-0">
                {displayText(safariPackages.pick_and_drop_display)}
              </p>
            </div>

            <div className="icons_restro">
              <i className="fa-solid fa-building"></i>
              <p className="mb-0">
                {displayText(safariPackages.package_range?.title)}
              </p>
            </div>
          </div>
        </div>

        <div className="footer_card row pb-2 px-2 align-items-center">
          <div className="col-6 col-lg-6 col-md-7">
            <Link
              to={`/operator/${safariPackages?.partner?.slug}/profile`}
              className="safaritourlogo"
            >
              <img
                src={safariPackages?.partner?.image_path || "/img/placeholder.jpg"}
                alt="Operator Logo"
                className="w-100"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/img/placeholder.jpg";
                }}
              />
            </Link>
          </div>

          <div className="col-6 col-md-5 col-lg-6">
            <div className="safari text-center">
              <div className="joinsafari package">
                <h6 className="titlePrice">
                  ₹ {rupeeFormat(safariPackages.total_price)}
                </h6>
                <Link
                  to={`/package/${safariPackages?.partner?.slug}/${safariPackages.package_slug}`}
                >
                  {PACKAGE?.DETAILS_BUTTON}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafariPackageCard;
